export default __webpack_public_path__ + "81596af.png";